module.exports = __webpack_public_path__ + "img/feetCombination.5326c24f.png";